import { formatMDYWithParam } from 'utils/formatDate';
import {
  defaultNewUserGridColumns,
  defaultUserGridColumns,
} from 'pages/role/controllers/constants';

export const mapToRoleUserGridColDef = (columns) => {
  let userGridColumns = [
    {
      field: '',
      checkboxSelection: true,
      filter: false,
      suppressHeaderMenuButton: true,
      width: 50,
      resizable: false,
    },
  ];
  const defaultConfig = {
    suppressHeaderMenuButton: true,
  };

  let newUserGridColumns = [...userGridColumns];

  const hiddenCol = ['id', 'assignedBy'];
  const hiddenNewUserCol = ['dateAssigned', 'assignedByName'];

  if (columns?.length > 0) {
    columns.forEach((col) => {
      if (hiddenCol.indexOf(col.fieldNameCamelCase) === -1) {
        if (col.fieldNameCamelCase === 'dateAssigned') {
          col = { ...col, cellRenderer: formatMDYWithParam, width: 150 };
        } else if (col.fieldNameCamelCase === 'email') {
          col = { ...col, flex: 1, minWidth: 200 };
        } else {
          col = { ...col, width: 150 };
        }

        const nextCol = { ...defaultConfig, ...col };

        if (hiddenNewUserCol.indexOf(col.fieldNameCamelCase) === -1) {
          newUserGridColumns.push(nextCol);
        }

        userGridColumns.push(nextCol);
      }
    });
  }

  return {
    userGridColumns: userGridColumns ?? defaultUserGridColumns,
    newUserGridColumns: newUserGridColumns ?? defaultNewUserGridColumns,
  };
};
